import { assert } from '@ember/debug';
import type { Column } from 'slickgrid';
import type { ColumnFilter } from '../components/aditools-device-table.ts';
import type { DeviceTableDeviceData } from '@ebiz/aditools-databook';

export default class PartialTextFilter implements ColumnFilter<DeviceTableDeviceData> {
  value: string;
  qaName?: string;
  updated?: (value: string) => void;

  constructor(initialValue?: string, qaName?: string, updated?: (value: string) => void) {
    this.value = initialValue ? initialValue : '';
    this.qaName = qaName;
    this.updated = updated;
  }

  populate(column: Column<DeviceTableDeviceData>): HTMLElement {
    if (!column) {
      throw 'column passed to populate is invalid';
    }
    const selection = this.generateDOMElement(column);
    selection.value = this.value;
    assert('At least one element is always generated', selection);
    return selection;
  }

  generateDOMElement(column: Column<DeviceTableDeviceData>): HTMLInputElement {
    const inputElement: HTMLInputElement = document.createElement('input');
    inputElement.id = `filter-${column.id}`;
    inputElement.type = 'text';
    inputElement.autocomplete = 'off';
    inputElement.className = 'slickgrid-filter-text';
    inputElement.ariaLabel = `${column.name} partial text`;
    inputElement.setAttribute('data-column-id', column.id.toString());
    if (this.qaName) {
      inputElement.setAttribute('data-qa-element', `device_table_${this.qaName}_input`);
    }
    return inputElement;
  }

  update(element: HTMLInputElement): void {
    this.value = element.value;
    if (this.updated) {
      this.updated(element.value);
    }
  }

  unpack(packedValues: string): void {
    if (packedValues) {
      const initialValues = JSON.parse(packedValues);
      if (Object.prototype.hasOwnProperty.call(initialValues, 'value')) {
        this.value = initialValues.value;
      }
    }
  }

  reset(): void {
    this.value = '';
  }

  pack(): string {
    return JSON.stringify({ value: this.value });
  }

  hasValue(): boolean {
    return this.value !== '';
  }

  filter(field: string): boolean {
    const effectiveField = field ?? '';
    return effectiveField.toUpperCase().indexOf(this.value.toUpperCase()) > -1;
  }
}
